import { RemoteRegraTributaria } from "../../../../data/usecases/regra-tributaria/remote-regra-tributaria";
import { RegraTributariaAdmin } from "../../../../domain/models/regra-tributaria";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteRegraTributaria = (): RegraTributariaAdmin =>
  new RemoteRegraTributaria("/admin/regras-tributarias", makeAxiosHttpClient());
